//
//
//
//
//
//
//
//
//
//
//
//

import { getUserCert } from '@/api/xiqueClinc'
export default {
  data () {
    return {
      type: '' // 1|普通用户 2|医生
    }
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    }
  },
  mounted () {
    this.getType()
  },
  methods: {
    // 获取用户角色
    getType () {
      getUserCert({
        accountid: this.accountid,
        clinicid: 1025
      }).then(res => {
        if (res.status === 'suc') {
          this.type = res.returnValue.type
          this.$store.commit('setUserCertType', this.type)
        }
      })
    }
  }
}
